import { useState } from 'react';

const API = process.env.REACT_APP_API_URL || '';

const SUCCESS_MESSAGE =
  'Jos tämä sähköposti löytyy rekisteröityneiden joukosta, lähetämme sähköpostin antamaasi sähköpostiin.';

const PUZZLE_ANSWERS = ['9', 'yhdeksän'];

function isPuzzleCorrect(value) {
  const v = (value || '').trim().toLowerCase();
  return PUZZLE_ANSWERS.some((a) => a.toLowerCase() === v);
}

export default function PasswordResetPage() {
  const [email, setEmail] = useState('');
  const [puzzleAnswer, setPuzzleAnswer] = useState('');
  const [notification, setNotification] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isPuzzleCorrect(puzzleAnswer)) {
      return;
    }
    const trimmed = (email || '').trim();
    if (!trimmed) {
      setNotification('Syötä sähköpostiosoite.');
      return;
    }
    setSubmitting(true);
    setNotification(null);
    fetch(`${API}/api/password-reset/request`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: trimmed }),
    })
      .then((res) => res.json())
      .then((data) => {
        setNotification(data.message || SUCCESS_MESSAGE);
        setEmail('');
      })
      .catch(() => setNotification('Pyyntö epäonnistui. Yritä myöhemmin uudelleen.'))
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="App-block">
      <h2>Unohditko salasanasi?</h2>
      <p className="PasswordReset-intro">
        Syötä rekisteröity sähköpostisi. Lähetämme sinulle linkin salasanan vaihtoon.
      </p>
      <form className="PasswordReset-form" onSubmit={handleSubmit}>
        <label htmlFor="password-reset-email">
          Sähköposti
          <input
            id="password-reset-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="sähköposti@esimerkki.fi"
            autoComplete="email"
            disabled={submitting}
          />
        </label>
        <div className="PasswordReset-puzzle">
          <div
            className="PasswordReset-puzzle-image"
            style={{
              width: 100,
              height: 20,
              backgroundImage: "url('/puzzle.jpg')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
          <input
            type="text"
            className="PasswordReset-puzzle-input"
            value={puzzleAnswer}
            onChange={(e) => setPuzzleAnswer(e.target.value)}
            placeholder="?"
            required
            disabled={submitting}
            aria-label="Puzzle answer"
          />
        </div>
        {notification && (
          <p className="PasswordReset-notification" role="status">
            {notification}
          </p>
        )}
        <button type="submit" className="Button" disabled={submitting}>
          {submitting ? 'Lähetetään…' : 'Lähetä'}
        </button>
      </form>
      <p>
        <a href="/">Takaisin etusivulle</a>
      </p>
    </div>
  );
}
